import { useState, useEffect } from "react"
import { useParams } from "react-router-dom";
import { useJsApiLoader } from '@react-google-maps/api';
import logoFollowingAlt from '../../../images/logoFollowingAlt.svg';
import checkBlack from '../../../images/checkBlack.svg';
import elipse from '../../../images/elipse.svg';
import facebookWhite from '../../../images/facebookWhite.svg';
import instagramWhite from '../../../images/instagramWhite.svg';
import twitterWhite from '../../../images/twitterWhite.svg';
import "./MessageFollowing.scss"
import { GOOGLE_MAPS_LIBRARIES } from "../../common/Maps/googleMapsConfig";

export const MessageFollowing = () => {

    const { status } = useParams();
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBRARIES,
    });

    const parseAction = () => {
        if (status === "finished") {
            return "Finalizado"
        }
        if (status === "canceled") {
            return "Cancelado"
        }
        if (status === "external") {
            return "de grúa asignado"
        }
        else {
            return ""
        }
    }

    if (!isLoaded) {
        return null;
    }

    const networks = [
        { src: facebookWhite, alt: "facebookWhite", url: "https://www.facebook.com/p/Tu-Gruero-100066840556940/" },
        { src: instagramWhite, alt: "instagramWhite", url: "https://www.instagram.com/tugruero/?hl=en" },
        { src: twitterWhite, alt: "twitterWhite", url: "https://x.com/tugruero" },
    ]

    return (

        <div className="message-following-component">
            <FollowingLinkHeader />
            <div className="following-message-body">
                <img src={checkBlack} alt="checkBlack" />
                <h6>Servicio {parseAction()}</h6>
                <p>¡Gracias por confiar en Tu Gruero!</p>
            </div>

            <div className="message-following-social-networks">
                <div>
                    {networks.map((n, index) => (
                        <a key={n.alt} href={n.url} target="_blank" >
                            <img src={n.src} alt="facebookWhite" />
                        </a>
                    ))}
                </div>
                <div>Siguenos en nuestras redes</div>
            </div>


            <img className="elipse" src={elipse} alt="elipse" />
        </div>
    )
}


export const FollowingLinkHeader = () => {
    return (
        <div className="following-message-header">
            <img src={logoFollowingAlt} alt="logoFollowingAlt" />
        </div>
    )
}
